import { FileViewer } from './FileViewer'
import { FileResource } from '../item/model/FileResource'
import './FileViewerDialog.scss'
import {Close} from '@mui/icons-material'
import { Dialog as MuiDialog , IconButton} from '@mui/material'

export const FileViewerDialog = (
    {
        open,
        onClose,
        title,
        file,
        isFetching
    }:{
        open: boolean,
        onClose: () => void,
        title: string,
        file: FileResource | undefined,
        isFetching: boolean
    }
) => {
        return (
        <MuiDialog
            open={open}
            onClose={onClose}
            classes={{
                root: 'viewer-custom-dialog-root',
                paper: 'viewer-custom-dialog-container',
            }}
            onClick={(event) =>
                event.stopPropagation()
            }
        >
            <div className="viewer-dialog" data-testid="file-viewer-dialog">
                <div className="viewer-dialog-header">
                    <div>
                        <div className="viewer-dialog-title">{title}</div>
                    </div>

                    <IconButton className="dialog-close" onClick={onClose} data-testid="close-btn">
                        <Close/>
                    </IconButton>
                </div>
                <div className="viewer-dialog-body">{<FileViewer 
                file={file} 
                isFetching={isFetching}
                onClose={onClose}
                />}
                </div>
            </div>
        </MuiDialog>
        )
}